import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import MuiTooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import type { SystemStyleObject } from '@mui/system';

import { skipPropForwardingFn } from '../../theme/utils.theme';

export type TooltipAdditionalProps = {
  tooltipSx?: SystemStyleObject<Theme>;
};

export type TooltipComponentProps = TooltipProps & TooltipAdditionalProps;

export const TooltipComponent = styled(
  ({ className, ...props }: TooltipComponentProps) => (
    <MuiTooltip { ...props } classes={{ popper: className }} />
  ),
  {
    shouldForwardProp: (prop) =>
      skipPropForwardingFn<TooltipAdditionalProps>(['tooltipSx'], prop),
  },
)(({ theme, tooltipSx }) => ({
  [`& .${ tooltipClasses.tooltip }`]: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.neutral.dark,
    color: '#fff',
    maxWidth: '500px',
    ...theme.typography.caption,
    ...tooltipSx,
  },

  [theme.breakpoints.down('sm')]: {
    [`& .${ tooltipClasses.tooltip }`]: {
      maxWidth: 'calc(100vw - 32px)',
    },
  },
}));
